import SearchSaleOrder from './SearchSaleOrder'

export default SearchSaleOrder
